import { COST_BREAKDOWN_DECIMAL_PRECISION } from "../constants"

import { formatNumber } from "@/utils/number"

export const formatCostBreakdownCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return ""

  // Format with exactly 4 decimal places and thousand separators
  return `$${formatNumber(value, COST_BREAKDOWN_DECIMAL_PRECISION, COST_BREAKDOWN_DECIMAL_PRECISION)}`
}
